import CollectionsAlertDialog from './CollectionsAlertDialog';

export default CollectionsAlertDialog;
